<template lang="pug">
div
  section
    AppTitle.u-mb-md(:title="$t('mantra')")

    div(v-if="$i18n.locale === 'en'")
      Content.is-normal(:highlight="false")
        h2 Intellectual property - Acceptable and unacceptable use of the website and content
        p All the Baianat website contents, features and functionality including, without limitations, all information, text, displays, images, video and audio, design, look, appearance, layouts, photographs, illustrations, motion, artwork and graphic material, names, logos, trademarks and services marks, are owned by Baianat company. By agreeing to the our copyrights policy, you agree to notify Baianat of any infringe upon any copyright or trademark. Any unauthorized use of our website material is considered a violation of our copyrights policy.

        h2 Open source
        p Baianat believes in the power of open sources and its role of boosting communities. This is why we have many open source contributions in different fields. These terms of use ensure you a personal, non-exclusive license to access and use the tools, resources and freebies available on the web site and owned by Baianat. You may access the material on the Sites only for your own personal, non-commercial use.

        h2 You must not:
        ul
          li Modify copies of any materials from the Site with the purpose of republishing it.
          li Use any illustrations, photographs, video or audio or any graphics on the website that is owned by Baianat and not included in the open source, tools or resources section. For example, you can’t use Baianat branding elements or its works branding elements including, without limitations( logo, illustrations, iconography, typo, text, custom videos, etc)
          li Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from the Sites.
          li Reproduce or create derivative works of, republish, any of the material on our Site.
          li Reverse-engineer or otherwise attempt to steal the software code of the Site.

        h2 Trademarks
        p Baianat and all its related names, logos, product and service names, designs, and slogans are trademarks of Baianat. You must not use such marks without our prior permission. And in case of referring to us, you must  follow our brand guidelines illustrated in the brand section. You may also refer to us or our website in a way that is fair, legal and doesn’t damage or take advantage of our reputation. You must not link to us in a way that suggests, endorses, approve or declare an opinion on our behalf.  All other names, logos, product and service names, designs, and slogans on the site are the trademarks of their respective owners.
    div(v-else)
      Content.is-normal(:highlight="false")
        h2 الملكية الفكرية-الاستخدام المقبول وغير المقبول للمحتوى والموقع.
        p جميع محتوى بيانات والمزايا والوظيفية بما يتضمن، بدون أي استثناء، جميع المعلومات والنصوص و العروض والصور و الفيديو و الصوت والتصميم والمظهر والمخططات والصور الفوتوغرافية والصور التوضيحية و الموشن والأعمال الفنية و مواد الجرافيك و الأسماء والشعارات والعلامة التجارية وعلامات الخدمة مملوكة لشركة بيانات. بالموافقة على سياسة حقوق النشر الخاصة بنا، فأنت توافق على إبلاغ بيانات بأي انتهاك يحدث لأي حق من حقوق النشر أو العلامة التجارية. يعتبر أي استخدام غير مصرح به لمواد مواقعنا الإلكتروني إنتهاكًا لسياسة حقوق التأليف والنشر الخاصة بنا.

        h2 المصدر المفتوح
        p تؤمن بيانات بأهمية المصادر المفتوحة ودورها في دفع المجتمع نحو الأمام. لهذا السبب لدينا العديد من المساهمات مفتوحة المصدر في مختلف المجالات.  تضمن لك شروط الاستخدام قدرتك على الحصول على ترخيص شخصي غير حصري للوصول إلى الأدوات والموارد والمزايا المجانية المتاحة على الموقع والمملوكة لبيانات واستخدامها. يجوز لك الوصول إلى المواد الموجودة على المواقع لاستخدامك الشخصي وليس من أجل الاستخدام التجاري.

        h2 لا يجب عليك:
        ul
          li  تعديل نسخ أي مواد من الموقع بغرض إعادة نشرها.
          li  استخدام أي رسوم توضيحية أو صور فوتوغرافية أو فيديو أو صوت أو جرافيك الموجودة على الموقع الخاص ببيانات ولا تندرج أسفل المصادر المفتوحة أو الأدوات أو الموارد. علي سبيل المثال، لا يمكنك استخدام عناصر العلامة التجارية الخاصة ببيانات بما يشمل ( الشعار والرسوم التوضيحية و الايقونوجرافي و الخطوط و النصوص ومقاطع الفيديو المخصصة…..إلخ).
          li  حذف أو تغيير أي من حقوق النشر أو العلامة التجارية أو غيرها من اشعارات حقوق الملكية من نسخ المواد على الموقع.
          li  إعادة إنشاء أو نشر أو خلق أعمال مشقة من المواد الموجودة على موقعنا.
          li عكس الهندسة أو محاولة سرقة الرموز البرمجية الخاصة بالموقع.

        h2 العلامات التجارية
        p بيانات، وجميع الأسماء ذات الصلة بها والشعارات وأسماء المنتجات والخدمات والتصميمات و عبارات الشعار كلها علامات تجارية خاصة ببيانات. يجب ألا تستخدم أي من هذه العلامات دون الحصول على إذن مسبق منا. وفي حالة الإشارة إلينا، يجب إتباع إرشادات العلامة التجارية الموضحة في قسم العلامة التجارية. يمكنك أيضًا الرجوع إلينا وإلي موقعنا بأي طريقة عادلة وقانونية بدون إلحاق الضرر بنا أو الاستفادة من سمعتنا. يجب ألا ترتبط بنا بطريقة تجعلك تقترح أو تؤيد أو توافق أو تُعلن رأيًا نيابة عنا. جميع الأسماء والشعارات وأسماء المنتجات والخدمات والتصاميم وعبارات الشعار على الموقع هي علامة تجارية لمالكيها.

</template>

<script>
import Content from '~/components/Content';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  ),
  components: {
    Content
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Copyrights",
    "pageDesc":"Our copyrights terms and rules protecting Baianat intellectual property for everything produced online or on ground.",
    "mantra":"Copyrights |policy."
  },
  "ar": {
    "pageTitle":"حقوق بيانات للتأليف والنشر.",
    "pageDesc":"تصف حقوق بيانات للتأليف والنشر لدينا التي تحمي حقوق الملكية الفكرية لكل ما تقوم بيانات بإنتاجه ونشره على الموقع أو غيره.",
    "mantra":"سياسة حقوق |التأليف والنشر."
  }
}
</i18n>
